import { render, staticRenderFns } from "./CelebrateSampleUpdate.vue?vue&type=template&id=1c87eddb&scoped=true"
import script from "./CelebrateSampleUpdate.vue?vue&type=script&lang=js"
export * from "./CelebrateSampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./CelebrateSampleUpdate.vue?vue&type=style&index=0&id=1c87eddb&lang=css"
import style1 from "./CelebrateSampleUpdate.vue?vue&type=style&index=1&id=1c87eddb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87eddb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c87eddb')) {
      api.createRecord('1c87eddb', component.options)
    } else {
      api.reload('1c87eddb', component.options)
    }
    module.hot.accept("./CelebrateSampleUpdate.vue?vue&type=template&id=1c87eddb&scoped=true", function () {
      api.rerender('1c87eddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/CelebrateSampleUpdate.vue"
export default component.exports